<template>
  <div class="row" :loading="loadingCountryResults" v-loading="loadingCountryResults"
    element-loading-spinner="qc-spinner">
    <div class="col-md-12 card">
      <div class="card-header">
        <div id="top-bar">
          <div>
            <div style="margin-top: auto">
              <div>
                <button v-if="mapSearch == false" class="btn pull-right" style="margin-left: 5px"
                  @click="resetCountryList(), (mapSearch = true)">
                  Map View
                </button>
                <button v-if="mapSearch == true" class="btn pull-right" style="margin-left: 5px"
                  @click="(input = ''), handleExpandChange(''), searchCountriesList(''), (mapSearch = false)">
                  Table View
                </button>
              </div>
              <h4 class="card-title" style="position: default; width: 20%">Country Insights</h4>
              <p style="margin-bottom: 0px;" v-if="!mapSearch">
                Select a country from the table below for more detailed information
              </p>
              <p style="margin-bottom: 0px;" v-else>
                Select a country from the map below for more detailed information
              </p>
            </div>
            <div style="margin-top: 10px">
              <div v-if="mapSearch == false">
                <el-input  id="search-bar" prefix-icon="el-icon-search"
                  @input="searchCountriesList(input)" remote placeholder="Search" v-model="input" :clearable="true"
                  style="z-index: 9999; margin-bottom: 10px" class="pull-left">
                </el-input>
              </div>
              <div v-else class="dropdown-grid-container">
                <label class="control-label" style="padding-top: 9px" >Select a map </label>
                <el-select v-model="selectName" class="" @change="changeMapData(selectName)">
                  <el-option v-for="options in mapSelectOptions" :value="options.value" :key="options.value"
                    :label="options.label"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <!-- <hr v-if="mapSearch" /> -->
        <div class="card-content row form-horizontal">
          <div style="margin: auto;">
            <div v-if="mapSearch && this.selectName != 'Institutions Map'">
              <country-info-map />
            </div>
          </div>
          <el-table v-if="countryResults.length > 0 && mapSearch == false" :data="pagedTableData"
            :default-sort="{ prop: 'name', order: 'ascending' }" class="table table-striped table-no-bordered"
            size="small" :row-key="(row) => row.id" :expand-row-keys="expandRowKeys" @row-click="handleExpandChange"
            @sort-change="orderRows">
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="col-md-12 alert alert-warning alert-with-icon"
                  v-if="loadingSpecificCountryResults == false && specificCountry.notification">
                  <span data-notify="icon" class="fa fa-exclamation"></span>
                  <span> {{ specificCountry.notification }}
                    <b><a v-if="specificCountry.notificationLink" :href="specificCountry.notificationLink"
                        target="_blank" class="notificationLink">{{ specificCountry.notificationLinkName }}
                      </a></b>
                  </span>
                </div>
                <div class="col-md-12 alert alert-warning alert-with-icon"
                  v-if='loadingSpecificCountryResults == false && publicHolidayNotificationArray.length > 0'>
                  <span data-notify="icon" class="fa fa-exclamation"></span>
                  <span v-if="loadingSpecificCountryResults == false">
                    {{ props.row.name }} is currently celebrating
                    <span v-for="data, index in publicHolidayNotificationArray">
                      <span v-if="index + 1 < publicHolidayNotificationArray.length"><b>{{ data }}</b>, </span> 
                      <span v-if="index + 1 == publicHolidayNotificationArray.length && publicHolidayNotificationArray.length != 1"> & <b>{{ data }}</b></span>
                      <span v-else-if="publicHolidayNotificationArray.length == 1"><b>{{ data }}</b></span>
                    </span>. 
                    Unfortunately, this may slow down verification times.
                  </span>
                </div>
                <a id="anchorId" href="#"></a>
                <div :loading="loadingSpecificCountryResults && $store.state.loadingChartData" v-loading="loadingSpecificCountryResults"
                  element-loading-spinner="qc-spinner" id="main-content">
                  <div v-if="loadingSpecificCountryResults == false">
                    <h4>{{ specificCountry.name }}</h4>
                    <div>
                      <p><b>Capital:</b> {{ specificCountry.capital }}</p>
                      <p><b>Population:</b> {{ specificCountry.population }}</p>
                      <p><b>Languages:</b> {{ specificCountry.languages }}</p>
                      <p>
                        <b>Current Number of Institutions:</b>
                        {{ props.row.instituteNumbers }}
                      </p>
                    </div>
                    <hr />
                    <h4>Verification Information</h4>
                    <div class="verification-grid-container">
                      <div>
                        <p>
                          <b>Average Verification Time:</b>
                        </p>
                        <div v-if="props.row.turnaround == -1">
                          <h3 style="color: #36A2EB">
                            n/a
                          </h3>
                        </div>
                        <div v-else>
                          <h3 v-if="props.row.turnaround == 1" style="color: #36A2EB">
                            {{ props.row.turnaround }} day
                          </h3>
                          <h3 v-else style="color: #36A2EB">
                            {{ props.row.turnaround }} days
                          </h3>
                        </div>
                        <br />
                        <p style="font-size: 12px">
                          *Average Global Verification Time:
                          <b>{{ props.row.averageVerificationTime }} days</b>
                        </p>
                      </div>
                      <div>
                        <p>
                          <b>Rate of Fraudulent Verifications:</b>
                        </p>
                        <div v-if="props.row.rateFake == -1">
                          <h3 style="color: #36A2EB">
                            n/a
                          </h3>
                        </div>
                        <h3 v-else style="color: #36A2EB">
                          {{ props.row.rateFake }}%
                        </h3>
                        <br />
                        <p style="font-size: 12px">
                          *Average Global Fraudulent Verifications:
                          <b>{{ props.row.globalVerificationPercentage }}%</b>
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div v-if="loadingSpecificCountryResults == false">
                      <h4>Student Mobility Information</h4>
                      <div class="grid-container">
                        <div style="min-width: 0px">
                          <h5>
                            <b>Inbound Student Mobility (2021)</b>
                          </h5>
                          <div style="margin-top: 5px" v-if="inboundChartData.datasets[0].data.length != 0">
                            <inbound-student-chart :chartData="inboundChartData" v-if="mapSearch == false"/>
                          </div>
                          <div v-else class="no-graph-data-div">
                            <div>
                              <p>
                                Not enough current data available
                              </p>
                            </div>
                          </div>
                        </div>
                        <div style="min-width: 0px">
                          <h5>
                            <b>Outbound Student Mobility (2021)</b>
                          </h5>
                          <div style="margin-top: 5px" v-if="
                            outboundChartData.datasets[0].data.length != 0 && loadingSpecificCountryResults == false
                          ">
                            <outbound-student-chart :chartData="outboundChartData" v-if="loadingSpecificCountryResults == false"/>
                          </div>
                          <div v-else class="no-graph-data-div">
                            <div>
                              <p>
                                Not enough current data available
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div v-if="loadingSpecificCountryResults == false">
                    <h4>Macro-Level Information</h4>
                    <div class="grid-container">
                      <div style="min-width: 0px">
                        <h5>
                          <b>{{ props.row.name }} Net Migration Statistics</b>
                        </h5>
                        <div style="margin-top: 5px" v-if="migrationChartData.datasets[0].data.length != 0 && loadingSpecificCountryResults == false">
                          <migration-chart :chartData="migrationChartData" v-if="loadingSpecificCountryResults == false"/>
                        </div>
                        <div v-else class="no-graph-data-div">
                          <div>
                            <p>
                              Not enough current data available
                            </p>
                          </div>
                        </div>
                      </div>
                      <div style="min-width: 0px">
                        <h5>
                          <b>{{ props.row.name }} GDP Per Capita ($)</b>
                        </h5>
                        <div style="margin-top: 5px" v-if="economicChartData.datasets[0].data.length != 0 && loadingSpecificCountryResults == false">
                          <economic-chart :chartData="economicChartData" v-if="loadingSpecificCountryResults == false"/>
                        </div>
                        <div v-else class="no-graph-data-div">
                          <div>
                            <p>
                              Not enough current data available
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- BRING IN THE RESULTS TABLE IF SELECTED AS COUNTRY -->
                  <!-- <div v-if="loadingSpecificCountryResults == false">
                    <hr />
                    <h4>{{ props.row.name }} Institutions</h4>

                    <institute-table :region="test" />
                  </div> -->
                  <hr />
                  <div v-if="loadingSpecificCountryResults == false">
                    <h4>Public Holidays</h4>
                    <el-table :data="pagedHolidayData" size="small" id="publicHolidayTable">
                      <el-table-column label="Holiday" min-width="125px">
                        <template slot-scope="props">
                         <span class="public-holiday-event">
                          {{ props.row.event }}
                         </span> 
                        </template>
                      </el-table-column>
                      <el-table-column label="Beginning" min-width="100px">
                        <template slot-scope="props">
                          <span>
                            {{ props.row.date }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Ending" min-width="100px">
                        <template slot-scope="props">
                          <span v-if="props.row.endDate">
                            {{ props.row.endDate }}
                          </span>
                          <span v-else>
                            {{ props.row.date }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Regions" min-width="100px">
                        <template slot-scope="props">
                          <span v-if="props.row.regions == ''">All Regions</span>
                          <span v-else> {{ props.row.regions }} </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <br />
                    <div class="col-sm-6 pagination-info" v-if="publicHolidayData.length > 0">
                      <p class="category">
                        Showing days {{ holidayFrom + 1 }} to {{ holidayTo }} of
                        {{ publicHolidayData.length }} public holidays
                      </p>
                    </div>
                    <div class="col-sm-6" style="margin-left: auto;" v-if="publicHolidayData.length > 0">
                      <div>
                        <p-pagination v-model="holidayPagination.currentPage" class="pull-right"
                          :per-page="holidayPagination.perPage" :total="holidayPagination.total">
                        </p-pagination>
                      </div>
                    </div>
                  </div>

                  <div v-if="loadingSpecificCountryResults == false" style="margin-top: 45px" id="indepth-div">
                    <div>
                      <hr />
                      <h4>{{ props.row.name }} In-Depth</h4>
                      <div v-if="specificCountry.government != ''">
                        <h5>
                          <b>Government:</b>
                        </h5>
                        <p v-for="data in specificCountry.government">
                          {{ data }}
                        </p>
                      </div>
                      <div v-if="specificCountry.economy != ''">
                        <h5>
                          <b>Economy:</b>
                        </h5>
                        <p v-for="data in specificCountry.economy">
                          {{ data }}
                        </p>
                      </div>
                      <div v-if="specificCountry.migration != ''">
                        <h5>
                          <b>Migration:</b>
                        </h5>
                        <p v-for="data in specificCountry.migration">
                          {{ data }}
                        </p>
                      </div>
                      <div v-if="specificCountry.educationSystems != ''">
                        <h5>
                          <b>Education Systems:</b>
                        </h5>
                        <p v-for="data in specificCountry.educationSystems">
                          <span
                            v-if="data != 'Primary Education' && data != 'Secondary Education' && data != 'Tertiary Education' && data != 'Middle Education' && data != 'Vocation Education' && data != 'Vocational Education'">
                            {{ data }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Country" prop="name" min-width="100px" sortable>
              <template slot-scope="props">
                <span style="white-space: nowrap"> {{ props.row.name }} </span>
              </template>
            </el-table-column>
            <el-table-column label="Avg. Verification Time" prop="turnaround" min-width="100px" sortable>
              <template slot-scope="props">
                <span v-if="props.row.turnaround == '-1'"> n/a </span>
                <span v-else-if="props.row.turnaround == '1'">
                  {{ props.row.turnaround }} day
                </span>
                <span v-else> {{ props.row.turnaround }} days </span>
              </template>
            </el-table-column>
            <el-table-column label="Fraudulent Verifications" prop="rateFake" min-width="100px" sortable>
              <template slot-scope="props">
                <span v-if="props.row.rateFake == -1"> n/a </span>
                <span v-else> {{ props.row.rateFake }}% </span>
              </template>
            </el-table-column>
            <el-table-column label="Current Number of Institutions" prop="instituteNumbers" min-width="100px" sortable>
              <template slot-scope="props">
                <span v-if="props.row.instituteNumbers == -1"> n/a </span>
                <span v-else> {{ props.row.instituteNumbers }} </span>
              </template>
            </el-table-column>
            <el-table-column label="Top Incoming Destinations" min-width="100px">
              <template slot-scope="props">
                <span v-if="!props.row.incoming"> n/a </span>
                <span v-else> {{ props.row.incoming }} </span>
              </template>
            </el-table-column>
            <el-table-column label="Top Outgoing Destinations" min-width="100px">
              <template slot-scope="props">
                <span v-if="!props.row.outgoing"> n/a </span>
                <span v-else> {{ props.row.outgoing }} </span>
              </template>
            </el-table-column>
          </el-table>
          <div v-else-if="
            this.countryResults.length == 0 &&
            this.loadingCountryResults == false
          ">
            <h5>No countries match your search</h5>
          </div>
          <div v-if="mapSearch == false">
            <div class="col-sm-6 pagination-info" v-if="countryResults.length > 0">
              <p class="category">
                Showing entries {{ from + 1 }} to {{ to }} of
                {{ countryResults.length }} countries
              </p>
            </div>
            <div class="col-sm-6" style="margin-left: auto" v-if="countryResults.length > 0">
              <div>
                <p-pagination v-model="pagination.currentPage" class="pull-right" :per-page="pagination.perPage"
                  :total="this.countryResults.length">
                </p-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Papa from "papaparse";
import PPagination from "src/components/Pagination.vue";
import InboundStudentChart from "./components/inboundStudentChart.vue";
import OutboundStudentChart from "./components/outboundStudentChart.vue";
import EconomicChart from "./components/economicGraph.vue";
import MigrationChart from "./components/migrationGraph.vue";
import CountryInfoMap from "./components/countryInfoMap.vue";
import store from "../../store";
import { mapGetters } from "vuex";
import InstituteSelect from "src/views/Verifications/components/InstituteSelect";
// import InstituteTable from "src/views/Verifications/components/InstituteTable";
import moment from 'moment'

export default {
  components: {
    CountryInfoMap,
    PPagination,
    InboundStudentChart,
    OutboundStudentChart,
    EconomicChart,
    MigrationChart,
    InstituteSelect,
    // InstituteTable,
    moment,
  },
  data() {
    return {
      currentDate: null,
      test: {
        name: "United Kingdom",
      },
      mapSelectOptions: [
        {
          value: "Annual Verification Times",
          label: "Annual Average Verification Times",
        },
        // {
        //   value: "Current Verification Times",
        //   label: "Current Verification Times",
        // },
        {
          value: "Fraudulent Verification Percentages",
          label: "Fraudulent Verifications",
        },
        {
          value: "Current Number of Institutions",
          label: "Current Number of Institutions",
        },
      ],
      averageVerificationTime: "",
      specificCountry: "",
      publicHolidayData: "",
      mapSearch: false,
      inboundChartData: {
        datasets: [
          {
            labels: [],
            data: [],
            backgroundColor: [
              "rgba(255, 99, 132)",
              "rgba(255, 159, 64)",
              "rgba(255, 205, 86)",
              "rgba(54, 162, 235)",
              "rgba(75, 192, 192)",
              "rgba(153, 102, 255)",
              "rgba(201, 203, 207)",
            ],
          },
        ],
      },
      outboundChartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgba(255, 99, 132)",
              "rgba(255, 159, 64)",
              "rgba(255, 205, 86)",
              "rgba(54, 162, 235)",
              "rgba(75, 192, 192)",
              "rgba(153, 102, 255)",
              "rgba(201, 203, 207)",
            ],
          },
        ],
      },
      input: "",
      pagination: {
        perPage: 15,
        currentPage: 1,
        total: 0,
      },
      holidayPagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
      },
      total: 0,
      invalidSearch: false,
      countryResults: [],
      expandRowKeys: [],
      countryNames: [],
      countryUrl: [],
      countries: [],
      loadingCountryResults: false,
      loadingSpecificCountryResults: false,
      publicHolidayNotificationArray: [],
      selectName: "",
      foundCountry: "",
      economicChartData: {
        labels: [],
        datasets: [
          {
            data: [],
            tension: 0,
            borderColor: "#36A2EB",
            fill: "none",
            hoverOffset: 4,
          },
        ],
      },
      migrationChartData: {
        labels: [],
        datasets: [
          {
            data: [],
            tension: 0.3,
            borderColor: "#36A2EB",
            fill: "none",
            hoverOffset: 4,
          },
        ],
      },
    };
  },
  async created() {
    this.loadingCountryResults = true;
    this.apiResults = await this.getAllCountryData();
    this.$store.state.loadMapName = "Annual Average Verification Times (Days)";
    this.selectName = "Annual Average Verification Times";
  },
  mounted() {
    this.currentDate = moment()
    this.publicHolidayNotificationArray = [];
  },
  beforeDestroy() {
    this.$store.state.loadMapName = "Annual Average Verification Times";
  },
  computed: {
    pagedTableData() {
      // BELOW: GOING THROUGH ALL COUNTRYRESULTS DATA & CONVERTING ANYTHING TO INTEGERS FOR SORTING
      for (let i = 0; i < this.countryResults.length; i++) {
        const country = this.countryResults[i];
        for (const key in country) {
          if (country.hasOwnProperty(key)) {
            const value = country[key];
            const parsedFloat = parseFloat(value);
            if (!isNaN(parsedFloat)) {
              country[key] = parseFloat(parsedFloat.toFixed(2));
            }
          }
        }
      }
      return this.countryResults.slice(
        this.pagination.perPage * this.pagination.currentPage -
        this.pagination.perPage,
        this.pagination.perPage * this.pagination.currentPage
      );
    },
    paginationCurrentPage() {
      return this.pagination.currentPage;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.pagination.total < highBound) {
        highBound = this.pagination.total;
      }
      return highBound;
    },
    pagedHolidayData() {
      return this.publicHolidayData.slice(
        this.holidayPagination.perPage * this.holidayPagination.currentPage -
        this.holidayPagination.perPage,
        this.holidayPagination.perPage * this.holidayPagination.currentPage
      );
    },
    paginationHolidayPage() {
      return this.holidayPagination.currentPage;
    },
    holidayFrom() {
      return (
        this.holidayPagination.perPage *
        (this.holidayPagination.currentPage - 1)
      );
    },
    holidayTo() {
      let holidayHighBound = this.holidayFrom + this.holidayPagination.perPage;
      if (this.holidayPagination.total < holidayHighBound) {
        holidayHighBound = this.holidayPagination.total;
      }
      return holidayHighBound;
    },
    ...mapGetters({
      selectedCountry: "getSelectedCountry",
    }),
  },
  watch: {
    selectedCountry: async function (val) {
      this.loadingSpecificCountryResults = true
      if (val != null) {
        for (let i = 0; i < this.countries.length; i++) {
          if (this.countries[i].name == val) {
            this.foundCountry = this.countries[i]
          }
        }
        this.input = this.foundCountry.name
        await this.searchCountriesList(this.foundCountry.name);
        await this.handleExpandChange({
          id: this.foundCountry.id,
          csv: this.foundCountry.csv,
        });
        this.mapSearch = false;
      }
    },
  },
  methods: {
    orderRows({ column, prop, order }) {
      this.input = "";
      this.sortColumn = prop;
      // BELOW: IF NO SORTING SELECTED REVERT TO ALPHABETICAL COUNTRY LIST
      if (!column || !prop || !order) {
        column = 'Country';
        prop = 'name';
        order = 'ascending';
      }
      this.countries.sort((a, b) => {
        const aValue = a[prop];
        const bValue = b[prop];
        // Below, checks if both values are strings. If true it will compare them as strings. If not it will compare as numerics
        const comparison = typeof aValue === 'string' && typeof bValue === 'string'
          ? aValue.localeCompare(bValue)
          : aValue - bValue;
        return order === 'ascending' ? comparison : -comparison;
      });
      this.countryResults = this.countries;
    },
    resetCountryList() {
      this.pagination.currentPage = 1
    },
    getPublicHolidayInformation() {
      for (let i = 0; i < this.publicHolidayData.length; i++) {
        let year = moment().format("YYYY")
        if (this.publicHolidayData[i].endDate) {
          let startDate = moment(this.publicHolidayData[i].date).format(`${year}-MM-DD`)
          let endDate = moment(this.publicHolidayData[i].endDate).format(`${year}-MM-DD`)
          let todayDate = this.currentDate.format("YYYY-MM-DD")
          if (moment(todayDate).isBetween(moment(startDate), moment(endDate)) || moment(startDate).format("DDDD-MM-YY") == moment(todayDate).format("DDDD-MM-YY")) {
            this.publicHolidayNotificationArray.push(this.publicHolidayData[i].event)
          }
        } else {
          if (this.publicHolidayData[i].date == this.currentDate.format("DD MMMM").toString()) {
            this.publicHolidayNotificationArray.push(this.publicHolidayData[i].event)
          }
        }
      }
    },
    changeMapData(value) {
      this.$store.commit("setMapData", value);
      this.selectName = value;
    },
    async handleExpandChange(row) {
      this.loadingSpecificCountryResults = true;
      const id = row.id;
      const lastId = this.expandRowKeys[0];
      this.expandRowKeys = id === lastId ? [] : [id];
      if(this.expandRowKeys.length == 0 && this.mapSearch) {
        this.expandRowKeys.push(this.foundCountry.id)
      }
      if(this.expandRowKeys.length != 0) {
        this.getCountryData(row.csv);
      }
    },
    searchCountriesList(input) {
      this.countryResults = [];
      this.invalidSearch = false;
      if (!input) {
        for (let i = 0; i < this.countries.length; i++) {
          this.countryResults.push(this.countries[i]);
        }
      } else {
        for (let i = 0; i < this.countries.length; i++) {
          if (
            this.countries[i].name.toLowerCase().includes(input.toLowerCase())
          ) {
            this.countryResults.push(this.countries[i]);
          }
        }
        if (this.countryResults.length == 0) {
          this.invalidSearch = true;
        }
      }
      this.pagination.total = this.countryResults.length;
      this.total = this.countryResults.length;
    },

    // BELOW - API CALL TO GET COUNTRY LIST AND HIGH LEVEL INFORMATION

    async getAllCountryData() {
      let url =
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vTXt-0DFCrfrP_IqWlr_FWr6ZOl76Aozi_mDFs_3QdZpBTiVSE0EeeKFmiJcsrS0eK2ceRk2BAoSMX5/pub?output=csv";

      await Papa.parse(url, {
        download: true,
        header: true,
        complete: this.allCountriesOnComplete,
      });
    },
    allCountriesOnComplete(results) {
      const resultsData = results.data
      const countryData = []
      for (let i = 0; i < resultsData.length; i++) {
        if (resultsData[i].Completed == 'Yes') {
          countryData.push(resultsData[i])
        }
      }
      const returnedCountries = [];
      store.state.fraudulentCountryMapData = [];
      store.state.turnaroundCountryMapData = [];
      store.state.fiftyPercentMapData = [];
      store.state.instituteNumbersMapData = [];
      store.state.fraudulentCountryMapData.push([
        "Country",
        "Frauduvalent Verifications (%)",
      ]);
      store.state.turnaroundCountryMapData.push([
        "Country",
        "Annual Average Verification Time (Days)",
      ]);
      store.state.fiftyPercentMapData.push([
        "Country",
        "Current Verification Times (Days)",
      ]);
      store.state.instituteNumbersMapData.push([
        "Country",
        "Current Number of Institutions",
      ]);
      for (let i = 0; i < countryData.length; i++) {
        returnedCountries.push({
          name: countryData[i].Country,
          id: i,
          link: countryData[i].Link,
          turnaround: countryData[i].Turnaround,
          fiftyPercentTurnaround: countryData[i].FiftyPercentTurnaround,
          instituteNumbers: countryData[i].InstituteNumbers,
          rateFake: countryData[i].RateFake,
          outgoing: countryData[i].Outgoing,
          incoming: countryData[i].Incoming,
          csv: countryData[i].Csv,
          averageVerificationTime: countryData[0].AverageVerificatonTime,
          globalVerificationPercentage:
            countryData[0].GlobalVerificationPercentage,
        });

        // BELOW: GETTING ALL MAP DATA INFORMATION AND PUSHING TO STATE
        // BELOW: PUSHING RATE OF FAKE VERFS TO STATE
        if (!isNaN(countryData[i].RateFake) && countryData[i].RateFake != -1) {
          store.state.fraudulentCountryMapData.push([
            countryData[i].Country,
            Number(countryData[i].RateFake),
          ]);
        }
        // BELOW: PUSHING TURNAROUND TIME TO STATE
        if (!isNaN(countryData[i].Turnaround) && countryData[i].Turnaround != -1) {
          store.state.turnaroundCountryMapData.push([
            countryData[i].Country,
            Number(countryData[i].Turnaround),
          ]);
        }
        // BELOW: PUSHING 50 PERCENTILE INFORMATION TO STATE
        if (!isNaN(countryData[i].FiftyPercentTurnaround) && countryData[i].FiftyPercentTurnaround != -1) {
          store.state.fiftyPercentMapData.push([
            countryData[i].Country,
            Number(countryData[i].FiftyPercentTurnaround),
          ]);
        }
        // BELOW: PUSHING INSTITUTE NUMBERS TO STATE
        if (!isNaN(countryData[i].InstituteNumbers)) {
          store.state.instituteNumbersMapData.push([
            countryData[i].Country,
            Number(countryData[i].InstituteNumbers),
          ]);
        }
      }
      this.countries = returnedCountries;
      this.countryResults = returnedCountries;
      this.loadingCountryResults = false;
      // BELOW: HACK TO FIX PAGINATION ON LOAD BUG
      this.searchCountriesList();
    },

    //BELOW: FUNCTION TO GET INDIVIDUAL COUNTRY DATA
    async getCountryData(csvInformation) {
      this.loadingSpecificCountryResults = true
      this.specificCountry = "";
      this.publicHolidayNotificationArray = [];
      let url = `${csvInformation}`;
      await Papa.parse(url, {
        download: true,
        header: true,
        complete: this.individualCountryOnComplete,
      });
    },

    async individualCountryOnComplete(results) {
      this.loadingSpecificCountryResults = true
      this.$store.state.loadingChartData = true
      const countryData = await results.data;
      const inboundCountries = [];
      const outboundCountries = [];
      const inboundCountriesNumbers = [];
      const outboundCountriesNumbers = [];
      const netMigrationYears = [];
      const netMigrationNumbers = [];
      const economyYears = [];
      const economyNumbers = [];
      const publicHolidayData = [];
      const migrationData = [];
      const economyData = [];
      const educationSystemsData = [];
      const governmentData = [];
      const languageData = [];
      // LOOP THROUGH VERTICAL LENGTH OF GOOGLE SHEET
      for (let i = 0; i < countryData.length; i++) {
        // GETTING INCOMING AND OUTGOING COUNTRY DATA
        if (countryData[i].Incoming) {
          inboundCountries.push(countryData[i].Incoming);
          inboundCountriesNumbers.push(countryData[i].IncomingNumbers);
        }
        if (countryData[i].Outgoing) {
          outboundCountries.push(countryData[i].Outgoing);
          outboundCountriesNumbers.push(countryData[i].OutgoingNumbers);
        }
        // GETTING ECONOMY CHART DATA
        if (countryData[i].EconomyNumbers) {
          economyYears.push(countryData[i].EconomyYears);
          economyNumbers.push(countryData[i].EconomyNumbers);
        }
        // GET MIGRATION GRAPH DATA
        if (countryData[i].NetMigrationNumbers) {
          netMigrationYears.push(countryData[i].NetMigrationYears);
          netMigrationNumbers.push(countryData[i].NetMigrationNumbers);
        }

        // GETTING INFORMATION ABOUT PUBLIC HOLIDAYS
        if (countryData[i].PublicHolidayEvent) {
          if (countryData[i].PublicHolidayEndDate) {
            publicHolidayData.push({
              date: moment(countryData[i].PublicHolidayDate).format("DD MMMM"),
              event: countryData[i].PublicHolidayEvent,
              regions: countryData[i].PublicHolidayRegions,
              endDate: moment(countryData[i].PublicHolidayEndDate).format("DD MMMM")
            });
          } else {
            publicHolidayData.push({
              date: moment(countryData[i].PublicHolidayDate).format("DD MMMM"),
              event: countryData[i].PublicHolidayEvent,
              regions: countryData[i].PublicHolidayRegions,
            });
          }
        }
        if (countryData[i].Government) {
          governmentData.push(countryData[i].Government);
        }
        if (countryData[i].Migration) {
          migrationData.push(countryData[i].Migration);
        }
        if (countryData[i].Economy) {
          economyData.push(countryData[i].Economy);
        }
        if (countryData[i].EducationSystems) {
          educationSystemsData.push(countryData[i].EducationSystems);
        }
        if(countryData[i].Languages) {
          languageData.push(countryData[i].Languages)
        }
      }
      const individualData = [];
      // GETTING DATA FROM FIRST ROW OF GOOGLE SHEET
      individualData.push({
        name: countryData[0].Name,
        capital: countryData[0].Capital,
        population: countryData[0].Population,
        languages: languageData.join(", "),
        rateFake: countryData[0].rateFake,
        religion: countryData[0].Religion,
        dataProtection: countryData[0].DataProtection,
        government: governmentData,
        economy: economyData,
        educationSystems: educationSystemsData,
        migration: migrationData,
        notification: countryData[0].Notification,
        notificationLink: countryData[0].NotificationLink,
        notificationLinkName: countryData[0].NotificationLinkName
      });
      this.inboundChartData.labels = inboundCountries;
      this.outboundChartData.labels = outboundCountries;
      this.inboundChartData.datasets[0].data = inboundCountriesNumbers;
      this.outboundChartData.datasets[0].data = outboundCountriesNumbers;
      this.migrationChartData.labels = netMigrationYears;
      this.migrationChartData.datasets[0].data = netMigrationNumbers;
      this.economicChartData.labels = economyYears;
      this.economicChartData.datasets[0].data = economyNumbers;
      this.publicHolidayData = publicHolidayData;
      this.holidayPagination.currentPage = 1;
      this.holidayPagination.total = await this.publicHolidayData.length;
      this.specificCountry = individualData[0];
      this.publicHolidayNotificationArray = [];
      this.getPublicHolidayInformation();
      this.$store.state.loadingChartData = false;
      this.loadingSpecificCountryResults = false;
      this.$scrollTo("#anchorId");
    },
  },
};
</script>

<style lang="scss" scoped>
#indepth-div p {
  text-align: justify;
}

h4 {
  color: #3ca5aa;
}

.grid-container,
.verification-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.dropdown-grid-container {
  display: grid;
  grid-template-columns: 1fr 8fr;
}
@media only screen and (max-width: 700px) {
  #main-content {
    width: 80vw;
  }
  .verification-grid-container {
    display: block !important;
    padding-bottom: 5px;
  }
  .dropdown-grid-container {
    display: grid;
    grid-template-columns: 1fr;
  }
}

@media only screen and (max-width: 1200px) {
  .grid-container {
    display: block;
    padding-bottom: 5px;
  }

  #search-bar {
    margin-bottom: 5px;
  }

  #top-bar {
    text-align: center;
  }
}

.no-graph-data-div {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  min-height: 250px !important;
}

.el-table tbody tr td:first-child {
  padding-right: 18px !important;
}

.notificationLink {
  color: #668cff;
}

.notificationLink:hover {
  color: #36A2EB;
}

.public-holiday-event {
  word-break: break-word !important;
}
</style>


<!-- Below: needs to not be scoped or else won't take effect  -->
<style lang="scss">
  .el-table__expanded-cell:hover {
    background-color: white !important;
  }
</style>
